const constants = {
  HOME: {
    HOME_CONTAINERS: 'homeContainers',
    HOME_JOURNIE_SECTION: 'journierewards',
    HOME_RESIDENTIAL_CUSTOMERS: 'homePageContent',
    HOME_LOCATIONS: 'homeLocations',
  },
  COMMON: {
    FOOTER: 'footer',
    NAVIGATION: 'navigation',
    EBILLING_POP_UP: {
      DEFAULT: 'contactCustomerCareeBillingContents',
      FOR_HOME: 'contactCustomerCareEBillingForHome',
      FOR_BUSINESS: 'contactCustomerCareEBillingForYourBusiness',
      BACKGROUND_IMAGE: 'ebillingPopupBackground',
    },
    OPEN_ACCOUNT_POP_UP: {
      DEFAULT: 'contactCustomerCareOpenAnAccountContents',
      FOR_HOME: 'contactCustomerCareOpenAnAccoutPopUpForHome',
      FOR_BUSINESS: 'contactCustomerCareOpenAnAccountBusiness',
      BACKGROUND_IMAGE: 'openAnAccountPopupBackground',
    },
    GIFTCARDS_POP_UP: {
      DEFAULT: 'propaneBackgroudImage',
      IMAGE: 'propanePopUpImage',
      HEADER:'propaneHeader',
      CHECK_YOUR_BALANCE: 'checkYourBalance',
      PURCHASE_A_GIFT_CARD: 'purchaseGiftCard',
      CORPORATE_OREDRS: 'corporateOrders',
      FOR_BUSINESS: 'forBusinessPropane',
    },
  },
  DEFAULT_MENU: {
    REQUEST_A_CALLBACK: 'REQUEST A CALLBACK',
    SEARCH_SITE: 'SEARCH SITE',
    FACEBOOK: 'FACEBOOK',
  },
  LOCATION_BLUEWAVE: {
    LOCATION_DETAILS_CONTENT: {
      PRODUCT_SUPPLIER: 'productSupplierInCityContent',
      PRODUCT_SUPPLIER_IMAGES: 'locationAddressProductSupplierImages',
      ALSO_AVAILABLE: 'locationDetailsAlsoAvailable',
      DIESEL_IMAGE: 'homeDiesel',
      HEATING_OIL_IMAGE: 'homeHeatingOil',
      LUBRICANTS_IMAGE: 'homeLubricants',
      PROPANE_IMAGE: 'homePropane',
      DEF_IMAGE: 'productDef',
    },
  },
  ABOUT_BLUEWAVE: {
    ABOUT_BLUEWAVE_SLUG: 'about',
    ABOUT_BLUEWAVE_TITLE: 'about island',
    ABOUT_NAVIGATION: 'about',
    HEALTH_AND_SAFETY: {
      SLUG: 'hse',
      TITLE: 'Health, Safety & Environment',
    },
  },
  THANKYOU_BLUEWAVE: {
    THANKYOU: {
      DEFAULT: 'ThankYou',
      HEADER_TEXT: 'residentialThankYouHeader',
      CONTENT: 'residentialThankYouContent',
    },
    RESIDENTIAL_EBILLING: {
      DEFAULT: 'residentialeBillingThankYou',
      HEADER_TEXT: 'residentialeBillingThankYouHeader',
      CONTENT_LIST: 'residentialThankYouContents',
      CONTENT: 'residentialThankYouContent ',
      TWITTER_LINK: 'residentialThankYouTwitterConnectLink',
    },
    COMMERCIAL_EBILLING: {
      DEFAULT: 'commercialThankYou',
      HEADER_TEXT: 'commercialThankYouHeader',
      CONTENT_LIST: 'commercialThankYouContents',
      CONTENT: 'commercialThankYouContent',
      TWITTER_LINK: 'comercialThankYouTwitterLink',
    },
    WELCOME: {
      DEFAULT: '',
      CONTENT: 'thankYouWelcomeContent',
    },
  },
  CONTACT_US: {
    CONTACT_NAVIGATION: 'contact',
  },
  PAGES: {
    PROPANE_YOU_TRUST: {
      DEFAULT: 'propaneYouCanTrust',
      TOP_BAR: 'propaneYouCanTrustHeader',
      IMAGE_CONTAINER: 'propaneYouCanTrustBackgroundImage',
      HEADER: 'propaneProviderHeader',
      CONTENT_LIST: {
        DEFAULT: 'propaneYouCanTrustContents',
        PROPANE_CONTACT_US: 'propaneContactUs',
        PROPANE_SERVICE_AREAS: 'propaneServiceAreas',
      },
    },
  },
};

export const LocationTypes = {
  Branch: 'Branch',
  Cardlock: 'Cardlock',
  Payment: 'Payment',
};

export const MenuType = [
  {
    path: 'about',
    name: 'about island'
  }
];
export const CommonBreadCrumb = {
  'whats-inside': "WHAT'S INSIDE",
  'owner-operators': 'OWNER/OPERATORS',
  'station-directory': 'FAS GAS PLUS STATIONS',
};

export default constants;

